import { createBlankDocument, type CurvaDocument } from "@/document/model/document";
import type { DocumentChange } from "@/document/model/documentChange";
import { StoreSubject } from "@/lib/store/StoreSubject";

function documentStateEqual(left: CurvaDocument, right: CurvaDocument): boolean {
  return left === right || left.revision === right.revision;
}

export class DocumentStore {
  readonly document = new StoreSubject<CurvaDocument>(createBlankDocument(), {
    equals: documentStateEqual,
  });
  private readonly changes = new WeakMap<CurvaDocument, DocumentChange>();

  getDocument = (): CurvaDocument => {
    return this.document.getValue();
  };

  getDocumentChange = (document: CurvaDocument): DocumentChange | undefined => {
    return this.changes.get(document);
  };

  setDocument = (
    document: CurvaDocument,
    change?: Omit<DocumentChange, "document">,
  ): void => {
    if (change) {
      this.changes.set(document, { ...change, document });
    }
    this.document.next(document);
  };
}

export const documentStore = new DocumentStore();
